export default "__VITE_ASSET__49a79b84__"